/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vault_Content_IncludedInputs */

const en_vault_content_included = /** @type {(inputs: Vault_Content_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault Content Included`)
};

const es_vault_content_included = /** @type {(inputs: Vault_Content_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contenido de bóveda incluido`)
};

const fr_vault_content_included = /** @type {(inputs: Vault_Content_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contenu du coffre-fort inclus`)
};

const de_vault_content_included = /** @type {(inputs: Vault_Content_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault-Inhalt inklusive`)
};

const ja_vault_content_included = /** @type {(inputs: Vault_Content_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保管庫コンテンツ込み`)
};

const zh_vault_content_included = /** @type {(inputs: Vault_Content_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已包含金库内容`)
};

const ar_vault_content_included = /** @type {(inputs: Vault_Content_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`محتوى الخزنة متضمن`)
};

const id_vault_content_included = /** @type {(inputs: Vault_Content_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termasuk Konten Vault`)
};

const it_vault_content_included = /** @type {(inputs: Vault_Content_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contenuto del Vault Incluso`)
};

const ru_vault_content_included = /** @type {(inputs: Vault_Content_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Содержимое хранилища включено`)
};

const pt_vault_content_included = /** @type {(inputs: Vault_Content_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conteúdo do Cofre Incluído`)
};

const ko_vault_content_included = /** @type {(inputs: Vault_Content_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`보관소(Vault) 콘텐츠 포함됨`)
};

/**
* | output |
* | --- |
* | "Vault Content Included" |
*
* @param {Vault_Content_IncludedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const vault_content_included = /** @type {((inputs?: Vault_Content_IncludedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vault_Content_IncludedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vault_content_included(inputs)
	if (locale === "es") return es_vault_content_included(inputs)
	if (locale === "fr") return fr_vault_content_included(inputs)
	if (locale === "de") return de_vault_content_included(inputs)
	if (locale === "ja") return ja_vault_content_included(inputs)
	if (locale === "zh") return zh_vault_content_included(inputs)
	if (locale === "ar") return ar_vault_content_included(inputs)
	if (locale === "id") return id_vault_content_included(inputs)
	if (locale === "it") return it_vault_content_included(inputs)
	if (locale === "ru") return ru_vault_content_included(inputs)
	if (locale === "pt") return pt_vault_content_included(inputs)
	return ko_vault_content_included(inputs)
});